import script from "./chart1.vue?vue&type=script&lang=ts&setup=true"
export * from "./chart1.vue?vue&type=script&lang=ts&setup=true"

import "./chart1.vue?vue&type=style&index=0&id=a3aaf314&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3aaf314"]])

export default __exports__